// extracted by mini-css-extract-plugin
module.exports = {"block":"BreadCrumb_block__024qY","crumb":"BreadCrumb_crumb__uafje","title":"BreadCrumb_title__FDJ_N"};